import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  amount: number
  loading: boolean
  onUpgradeClick: () => void
  onAllPlansClick: () => void
}

export const Buttons: React.FC<Props> = ({
  amount,
  loading,
  onUpgradeClick,
  onAllPlansClick,
}) => (
  <div className={css.buttons}>
    <Button
      className={css.button}
      label={`Upgrade for $${amount}`}
      loading={loading}
      onClick={onUpgradeClick}
    />
    <button
      className={clsJoin(css.button, css.button_text)}
      onClick={onAllPlansClick}
    >
      See all features
    </button>
  </div>
)
